import { TagType } from '../types';

export const getTagType = (payment_status?: string): TagType => {
  switch (payment_status?.toLowerCase()) {
    case 'completed':
      return TagType.COMPLETED;
    case 'in progress':
    case 'pending collection':
      return TagType.PROGRESS;
    case 'request to cancel':
    case 'pending release payment':
      return TagType.REQUEST;
    case 'failed':
    case 'cancel':
    case 'rejected':
    case 'suspended':
    case 'refunded':
      return TagType.CANCEL;
    case 'pending':
    case 'draft':
    case 'pending approval':
      return TagType.PENDING;
    case 'link expired':
      return TagType.GREY;
    default:
      return TagType.PENDING;
  }
};
